import { render } from "./set-worker.vue?vue&type=template&id=2d77b21c&scoped=true&ts=true"
import script from "./set-worker.vue?vue&type=script&lang=ts"
export * from "./set-worker.vue?vue&type=script&lang=ts"

import "./set-worker.vue?vue&type=style&index=0&id=2d77b21c&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d77b21c"]])

export default __exports__